import { render, staticRenderFns } from "./ProductsTableActions.vue?vue&type=template&id=86fd6652&"
import script from "./ProductsTableActions.vue?vue&type=script&lang=js&"
export * from "./ProductsTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports